class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            // Extract and execute script tags, this is needed for updating PLPItems global JS object
            const scripts = recommendations.getElementsByTagName('script');
            for (let script of scripts) {
              const newScript = document.createElement('script');
              newScript.text = script.textContent;
              document.head.appendChild(newScript).parentNode.removeChild(newScript);
            }
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .then(() => {
          const swiper = new Swiper(this.querySelector('.js-ProductCarousel_Carousel'), {
              loop: false,
              watchSlidesProgress: true,
              slidesPerView: 1.2,
              centeredSlides: true,
              spaceBetween: 15,
              speed: 500,
              slideClass: 'js-ProductCarousel_Slide',
              breakpointsInverse: true,
              breakpoints: {
                  768: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                      centeredSlides: false
                  },
                  1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                      centeredSlides: false
                  },
                  1440: {
                      slidesPerView: 4,
                      spaceBetween: 30,
                      centeredSlides: false
                  }
              },
              pagination: {
                  el: this.querySelector('.sec-ProductCarousel_Paging'),
                  type: 'bullets',
                  clickable: true,
                  bulletClass: 'sec-ProductCarousel_Bullet',
                  bulletActiveClass: 'sec-ProductCarousel_Bullet-active'
              }
          });
        })
        .then(() => {
          // Load Trustbox widgets after product recommendations have been loaded
          if (typeof window.Trustpilot === 'object') {
            const TrustboxWidgets = this.querySelectorAll('.trustpilot-widget');
            TrustboxWidgets.forEach((widget) => {
              window.Trustpilot.loadFromElement(widget);
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);